import { RootState } from '../../../../redux/store';
import { ChatPersonalizationState } from '../../../../redux/features/chatPersonalization/chatPersonalizationState';

export const selectChatPersonalizationState = (state: RootState): ChatPersonalizationState => {
    return state.chatPersonalization;
};
